import React from 'react';
import { motion } from 'framer-motion';
import styles from './styles/home.module.css';
import ImageCarousel from '../components/ImageCarousel'
import homeBackground from '../assets/backgorund/home2.jpg';
import homeBackground2 from '../assets/backgorund/home3.jpg';
import homeBackground3 from '../assets/backgorund/home4.jpg';

const Home = () => {
  return (
    <div className={styles.home}>
    <ImageCarousel images={[homeBackground3, homeBackground, homeBackground2]} height = '620px'/>
        <motion.h3
          className={styles.lead}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          style={{ marginTop: '20px' }}
        >
          The world changes when one person decides that "enough is enough." In 2015, Ashok Deshmane made a choice. He chose not to look away. He chose to believe that 18 children, forgotten by circumstance, deserved a destiny defined by their dreams, not their poverty.
        </motion.h3>

        <motion.h3
          className={styles.tagline}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          That choice became Snehwan.
        </motion.h3>

        <motion.h3
          className={styles.body}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
        What started as a flicker of hope for 18 souls has become a blazing fire of transformation for 180 children. We are not just an organisation; we are a revolution of love. We are a fortress where hunger is replaced by nutrition, fear is replaced by shelter, and ignorance is defeated by quality education.  Snehwan combines quality education with the freedom to pursue passions. 
        </motion.h3>

        <motion.h3
          className={styles.body}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          We are proving, every single day, that when you nurture a child with love, you don't just save a life—you raise a generation that will change the world. 
        </motion.h3>

        <motion.h3
          className={styles.cta}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          Be the spark. Be the change. Be Snehwan.
        </motion.h3>

 
    </div>
  );
};

export default Home;